export const OPERATOR_TYPES_1 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
];

export const OPERATOR_TYPES_2 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'is_present',
    label: 'Is present',
  },
  {
    value: 'is_not_present',
    label: 'Is not present',
  },
];

export const OPERATOR_TYPES_3 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'contains',
    label: 'Contains',
  },
  {
    value: 'does_not_contain',
    label: 'Does not contain',
  },
];

export const OPERATOR_TYPES_4 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'is_present',
    label: 'Is present',
  },
  {
    value: 'is_not_present',
    label: 'Is not present',
  },
  {
    value: 'is_greater_than',
    label: 'Is greater than',
  },
  {
    value: 'is_less_than',
    label: 'Is less than',
  },
  // [PROSPEK] 2026-06-20 Add relative day operators to legacy campaign/filter inputs
  {
    value: 'days_before',
    label: 'Before the last X days',
  },
  {
    value: 'days_after',
    label: 'Within the last X days',
  },
  // [/PROSPEK]
];

export const OPERATOR_TYPES_5 = [
  {
    value: 'is_greater_than',
    label: 'Is greater than',
  },
  {
    value: 'is_less_than',
    label: 'Is less than',
  },
  // [PROSPEK] 2026-06-20 Clarify days_before copy while preserving legacy OPERATOR_TYPES_5 reuse
  {
    value: 'days_before',
    label: 'Before the last X days',
  },
  // [/PROSPEK]
];

// [PROSPEK] 2026-06-20 Keep days_after restricted to legacy date filter rows
export const OPERATOR_TYPES_6 = [
  ...OPERATOR_TYPES_5,
  {
    value: 'days_after',
    label: 'Within the last X days',
  },
];
// [/PROSPEK]
